import "./../../styles.css";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import { Row, Col, Card } from "antd";
import { BarChartOutlined } from "@ant-design/icons";
import { UNITS } from "components/Common/Constants";
import { VEHICLE_ANALYTICS } from "components/Common/svgIconComponents";
import { getVehicleDistance } from "apis/vehicleAnalyticsApis";
import TripDetailsCard from "./TripDetailsCard";
import { getData } from "apis/dataApis";
import RouteMap from "components/Common/Maps/RouteMap";

const tripDetailsTitle = (
  <div className="vaCardTitle">
    <VEHICLE_ANALYTICS.TRIPS />
    <span>Trip Details</span>
  </div>
);

const TripDetailsModal = ({ tripDetailsData }) => {
  const eol = useSelector((state) => state.eol);
  const vehicle = eol?.vehicleDetails;

  const { data, isLoading, isError, error, } = useQuery({
    queryKey: ['chartData', vehicle?.vehImei, tripDetailsData],
    queryFn: () => getData(vehicle?.vehImei, 
      ['latitude', 'longitude'], 
      "LOCATION", tripDetailsData?.startTime, tripDetailsData?.endTime, '1m'),      
    retry: 2,
    keepPreviousData: true,
    enabled: !!(vehicle?.vehImei, tripDetailsData?.startTime),
  });

  // const {
  //   data: vehicleDistanceData,
  //   // isLoading: vehicleDistanceLoading,
  //   // isError: vehicleDistanceIsError,
  //   // error: vehicleDistanceError,
  // } = useQuery({
  //   queryKey: [
  //     "vehicleDistance",
  //     vehicleDetails?.vehImei,
  //     selectedDateRange,
  //     datePickerType,
  //   ],
  //   queryFn: () =>
  //     getVehicleDistance(
  //       vehicleDetails?.vehImei,
  //       selectedDateRange,
  //       datePickerType
  //     ),
  //   keepPreviousData: true,
  //   enabled: !!(vehicleDetails?.vehImei && selectedDateRange && datePickerType),
  //   staleTime: 1 * 10 * 60 * 1000,
  // });

  const routes = data?.data?.map((entry) => [entry?.latitude, entry?.longitude]);

  return (
    <Row gutter={[16, 16]}>
      <Col xs={24} md={24} lg={6}>
        <TripDetailsCard
          tripCardTitle={tripDetailsTitle}
          tripDetails={tripDetailsData}
        />
      </Col>
      <Col xs={24} md={24} lg={18}>
        <Card
          bordered={false}
          className="locations-card"
          title={"Route Map"}
          style={{ minHeight: "715px" }}
        >
          <RouteMap
            routes={routes}
            isLoading={isLoading}
            isError={isError}
            dataErrorMsg={error?.message}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default TripDetailsModal;
